module.exports = __webpack_public_path__ + "img/brown-hairy-grass-10.86381874.png";